import { toast } from 'react-toastify';

// Configurazione per le notifiche
const toastConfig = {
  position: "top-right",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

// Funzioni helper per notifiche
export const notify = {
  success: (message) => {
    toast.success(message, toastConfig);
  },
  
  error: (message) => {
    toast.error(message, toastConfig);
  },
  
  info: (message) => {
    toast.info(message, toastConfig);
  },
  
  warning: (message) => {
    toast.warning(message, toastConfig);
  },
  
  // Notifica di conferma personalizzata
  confirm: (message, onConfirm, onCancel) => {
    const ConfirmToast = ({ closeToast }) => (
      <div>
        <p className="mb-3">{message}</p>
        <div className="flex gap-2">
          <button
            onClick={() => {
              onConfirm();
              closeToast();
            }}
            className="px-4 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 text-sm"
          >
            Conferma
          </button>
          <button
            onClick={() => {
              if (onCancel) onCancel();
              closeToast();
            }}
            className="px-4 py-1 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 text-sm"
          >
            Annulla
          </button>
        </div>
      </div>
    );

    toast(<ConfirmToast />, {
      ...toastConfig,
      autoClose: false,
      closeButton: false,
    });
  },

  // Notifica di caricamento
  loading: (message) => {
    return toast.loading(message, toastConfig);
  },

  // Chiude una notifica senza sostituirla
  dismiss: (toastId) => {
    toast.dismiss(toastId);
  },

  // Aggiorna notifica di caricamento.
  // Si accettano sia `render` sia `message`: in giro per il software si
  // usano entrambe le forme e con la sola `message` la maggior parte
  // delle conferme compariva senza testo.
  update: (toastId, { type, message, render }) => {
    toast.update(toastId, {
      render: render !== undefined ? render : message,
      type: type,
      isLoading: false,
      autoClose: 3000,
    });
  }
};

export default notify;

